import React from "react";
import { useState } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

function Newsletter() {
  const handleSubmit = (e) => {
    e.preventDefault();
    const magicUrl = `https://magic.beehiiv.com/v1/9b0f4e6e-25cf-44d1-a749-560638c423bb?email={{email}}&redirect_to=https%3A%2F%2Fwww.furbabies.ai%2Fnewsletter`;
    window.open(magicUrl, "_blank");
  };
  return (
    <section>
      <Helmet>
        <title>FurNews Newsletter – Furbabies.AI</title>
        <meta
          name="description"
          content="Join thousands of pet lovers. Get weekly pet health tips, nutrition guides, and AI-powered care advice delivered free to your inbox."
        />
      </Helmet>

      <Navbar />

      {/* HERO */}
      <div style={styles.hero}>
        {/* Decorative paws */}
        <div
          style={{
            position: "absolute",
            left: "6%",
            top: "25%",
            fontSize: "3rem",
            pointerEvents: "none",
          }}
        >
          <i
            className="fa fa-paw"
            style={{ color: "white", opacity: 0.35 }}
          ></i>
        </div>
        <div
          style={{
            position: "absolute",
            right: "8%",
            top: "40%",
            fontSize: "2rem",
            pointerEvents: "none",
          }}
        >
          <i
            className="fa fa-paw"
            style={{ color: "white", opacity: 0.25 }}
          ></i>
        </div>
        <div
          style={{
            position: "absolute",
            left: "15%",
            bottom: "20%",
            fontSize: "1.5rem",
            pointerEvents: "none",
          }}
        >
          <i className="fa fa-paw" style={{ color: "white", opacity: 0.2 }}></i>
        </div>

        <motion.h1
          style={styles.heroTitle}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          FurNews
        </motion.h1>
        <motion.p
          style={styles.heroSubtitle}
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.7 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          The weekly newsletter for pet lovers who want the best for their
          furbabies
        </motion.p>
        <motion.p
          style={styles.heroMeta}
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.5 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          ✉️ Every week &nbsp;•&nbsp; Free forever &nbsp;•&nbsp; No spam ever
        </motion.p>
      </div>

      {/* WHAT YOU GET */}
      <div style={styles.benefitsSection}>
        <div style={styles.benefitsInner}>
          <motion.h2
            style={styles.benefitsTitle}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            What's Inside Every Issue
          </motion.h2>

          <div style={styles.benefitsGrid}>
            {[
              {
                icon: "fa-heartbeat",
                title: "Pet Health Tips",
                desc: "Early warning signs, home checks, and when to see a vet — explained simply.",
              },
              {
                icon: "fa-leaf",
                title: "Nutrition Guides",
                desc: "What to feed your furbaby.",
              },
              {
                icon: "fa-paw",
                title: "Furbaby Stories",
                desc: "Heartwarming stories from pet lovers in our community.",
              },
            ].map((item, i) => (
              <motion.div
                key={i}
                style={styles.benefitCard}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.03)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <div style={styles.benefitIcon}>
                  <i
                    className={`fa ${item.icon}`}
                    style={{ color: "#967d6c", fontSize: "1.5rem" }}
                  ></i>
                </div>
                <h3 style={styles.benefitTitle}>{item.title}</h3>
                <p style={styles.benefitDesc}>{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* SIGNUP FORM */}
      <div style={styles.formSection}>
        <div style={styles.formInner}>
          <motion.h2
            style={styles.formTitle}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Join Thousands of Pet Lovers
          </motion.h2>
          <motion.p
            style={styles.formSubtitle}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 0.6 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            Get FurNews delivered to your inbox every week. Free forever.
          </motion.p>

          {/* 
            ✅ PASTE YOUR BEEHIIV IFRAME HERE
            Replace the src with your real Beehiiv embed URL
            Get it from: Beehiiv Dashboard → Grow → Forms → Embed Form
          */}
          <motion.div
            style={styles.iframeWrapper}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.6 }}
          >
            <form onSubmit={handleSubmit} style={styles.form}>
              <button type="submit" style={styles.submitButton}>
                Subscribe Free
              </button>
            </form>
          </motion.div>

          <p style={styles.privacy}>
            <i
              className="fa fa-lock"
              style={{ color: "#bda697", marginRight: "6px" }}
            ></i>
            We respect your privacy. Unsubscribe anytime. No spam, ever.
          </p>

          {/* LINK TO PAST ISSUES */}
          <div style={styles.pastIssues}>
            <p style={styles.pastIssuesText}>
              Want to see what you're signing up for?
            </p>
            <Link to="/furnews" style={styles.pastIssuesLink}>
              Browse past FurNews issues →
            </Link>
          </div>
        </div>
      </div>

      {/* BOTTOM CTA */}
      <section style={styles.ctaSection}>
        <motion.h2
          style={styles.ctaTitle}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Don't Delay. Try Furbabies.AI Today!
        </motion.h2>
        <Link to="/signup" style={styles.ctaButton}>
          Sign Up for Free
        </Link>
      </section>

      <Footer />
    </section>
  );
}

const styles = {
  hero: {
    background: "#BDA697",
    textAlign: "center",
    padding: "80px 20px 80px",
    marginTop: "11rem",
    position: "relative",
    overflow: "hidden",
  },
  heroTitle: {
    fontFamily: "'Poltawski Nowy', serif",
    fontSize: "clamp(3.5rem, 10vw, 6rem)",
    fontWeight: "bold",
    color: "white",
    marginBottom: "16px",
    lineHeight: "1.1",
  },
  heroSubtitle: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "1.15rem",
    color: "#222222",
    opacity: 0.7,
    marginBottom: "12px",
    maxWidth: "560px",
    margin: "0 auto 12px",
  },
  heroMeta: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.95rem",
    color: "#222222",
    opacity: 0.5,
    marginTop: "12px",
  },

  benefitsSection: { background: "#ffffff", padding: "80px 20px" },
  benefitsInner: { maxWidth: "1100px", margin: "0 auto" },
  benefitsTitle: {
    fontFamily: "'Poltawski Nowy', serif",
    fontSize: "clamp(2rem, 5vw, 3rem)",
    fontWeight: "bold",
    color: "#222222",
    textAlign: "center",
    marginBottom: "48px",
  },
  benefitsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "24px",
  },
  benefitCard: {
    background: "#f4ede7",
    borderRadius: "16px",
    padding: "28px",
    transition: "transform 0.2s ease",
    cursor: "default",
  },
  benefitIcon: {
    width: "52px",
    height: "52px",
    background: "#e8e1da",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
  },
  benefitTitle: {
    fontFamily: "'Poltawski Nowy', serif",
    fontSize: "1.15rem",
    fontWeight: "bold",
    color: "#222222",
    marginBottom: "8px",
  },
  benefitDesc: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.9rem",
    color: "#222222",
    opacity: 0.6,
    lineHeight: "1.7",
  },

  formSection: { background: "#e8e1da", padding: "80px 20px" },
  formInner: { maxWidth: "640px", margin: "0 auto", textAlign: "center" },
  formTitle: {
    fontFamily: "'Poltawski Nowy', serif",
    fontSize: "clamp(2rem, 5vw, 3rem)",
    fontWeight: "bold",
    color: "#222222",
    marginBottom: "12px",
  },
  formSubtitle: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "1.05rem",
    color: "#222222",
    opacity: 0.6,
    marginBottom: "36px",
  },
  iframeWrapper: { marginBottom: "16px" },
  privacy: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.85rem",
    color: "#999",
    marginTop: "16px",
  },
  pastIssues: {
    marginTop: "32px",
    padding: "20px",
    background: "#ffffff",
    borderRadius: "12px",
  },
  pastIssuesText: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.9rem",
    color: "#555",
    marginBottom: "8px",
  },
  pastIssuesLink: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.95rem",
    color: "#967d6c",
    fontWeight: "700",
    textDecoration: "none",
  },

  ctaSection: {
    background: "#ffffff",
    textAlign: "center",
    padding: "80px 20px",
  },
  ctaTitle: {
    fontFamily: "'Poltawski Nowy', serif",
    fontSize: "clamp(2rem, 5vw, 3.5rem)",
    fontWeight: "bold",
    color: "#222222",
    marginBottom: "16px",
  },
  ctaText: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "1.1rem",
    color: "#222222",
    opacity: 0.6,
    marginBottom: "36px",
  },
  ctaButton: {
    display: "inline-block",
    background: "#967d6c",
    color: "white",
    padding: "16px 48px",
    borderRadius: "9999px",
    fontFamily: "'Poppins', sans-serif",
    fontWeight: "bold",
    fontSize: "1.1rem",
    textDecoration: "none",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  input: {
    padding: "14px 20px",
    borderRadius: "9999px",
    border: "2px solid #e0d5ce",
    fontSize: "1rem",
    fontFamily: "'Poppins', sans-serif",
    outline: "none",
  },

  submitButton: {
    background: "#967d6c",
    color: "#fff",
    padding: "14px",
    borderRadius: "9999px",
    border: "none",
    fontSize: "1rem",
    fontWeight: "bold",
    cursor: "pointer",
  },
};

export default Newsletter;
